import Scrollbars from "react-custom-scrollbars-2";
const CustomScrollbars = (props:any) => {
    let autoHeightMin = props.autoHeightMin || 0;
    let autoHeightMax = props.autoHeightMax || 200;
    let styles = props.style || {};
    let autoHeights:any = props.autoHeight ? true : false;
    let className = props.className ? props.className : "";
  return (
    <Scrollbars
      autoHide
      autoHeight={autoHeights}
      autoHeightMax = {autoHeightMax}
      autoHeightMin={autoHeightMin}
      renderThumbVertical={({ style, ...props }: any) => (
        <div {...props} style={{ ...style, backgroundColor: "#667897"}} />
      )}
      renderTrackHorizontal={({ style, ...props }: any) => (
        <div {...props} style={{ ...style, backgroundColor: "#667897" }} />
      )}
      style={styles}
      className={className}
    >
      {props.children}  
    </Scrollbars>
  );
};

export default CustomScrollbars;
